import React from 'react';
import { t } from 'i18n';

import Dialog from 'Components/Base/Dialog';

const i18nOpts = { scope: 'place_contacts.admin_panel.view' };

const DeleteModal = ({
  isOpen,
  isDeleting,
  deleteError,
  onClose,
  onConfirm,
}) => (
  <Dialog
    className="place_contact_delete_dialog"
    title=" "
    isOpen={isOpen}
    onClose={isDeleting ? null : onClose}
    content={
      <div>
        <p className="delete_message">{t('delete_confirmation', i18nOpts)}</p>
        {deleteError && <p className="delete_error">{t('delete_error', i18nOpts)}</p>}
      </div>
    }
    footer={
      <div className="delete_actions">
        <button
          type="button"
          className="buttonV2 button-subtle"
          onClick={onClose}
          disabled={isDeleting}
        >
          {t('cancel', i18nOpts)}
        </button>
        <button
          type="button"
          className="buttonV2"
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {t('ok', i18nOpts)}
        </button>
      </div>
    }
  />
);

export default DeleteModal;
